import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { healthCheckStatsUrl } from '@app/definition/API';
import useLoadData from '@app/common/loadData/useLoadData';
import { StatsI } from './types';

const useStats = (): {
  loading: boolean;
  error: boolean;
  stats: StatsI;
} => {
  const dispatch = useDispatch();
  const initialState = useMemo(
    () => ({
      ordered: 0,
      confirmed: 0,
      pending: 0,
      done: 0,
    }),
    []
  );
  const [stats, setStats] = useState<StatsI>(initialState);
  const { error, loading, loadData } = useLoadData<StatsI>();

  useEffect(() => {
    const fetchData = async () => {
      const data = await loadData(healthCheckStatsUrl);
      if (!data.error && data.data) {
        setStats(data.data);
      }
    };
    fetchData();
  }, [dispatch, loadData, setStats, initialState]);

  return {
    stats,
    loading,
    error,
  };
};

export default useStats;
